import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

// ===== Public form helpers =====
export const submitContact = (payload) => api.post("/contact", payload).then((r) => r.data);
export const submitDriverApply = (payload) => api.post("/drivers/apply", payload).then((r) => r.data);
export const submitMerchantApply = (payload) => api.post("/merchants/apply", payload).then((r) => r.data);
export const submitServiceProApply = (payload) => api.post("/service-pros/apply", payload).then((r) => r.data);
export const submitAccountDeletion = (payload) => api.post("/account-deletion", payload).then((r) => r.data);
export const joinWaitlist = (payload) => api.post("/waitlist", payload).then((r) => r.data);
export const getStats = () => api.get("/stats").then((r) => r.data);

// ===== Admin =====
export const ADMIN_TOKEN_KEY = "ih_admin_token";

export const adminApi = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

adminApi.interceptors.request.use((config) => {
  const token = localStorage.getItem(ADMIN_TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const adminLogin = (email, password) =>
  adminApi.post("/admin/login", { email, password }).then((r) => r.data);

export const adminMe = () => adminApi.get("/admin/me").then((r) => r.data);
export const adminSummary = () => adminApi.get("/admin/summary").then((r) => r.data);
export const adminContacts = () => adminApi.get("/admin/contacts").then((r) => r.data);
export const adminDrivers = () => adminApi.get("/admin/drivers").then((r) => r.data);
export const adminMerchants = (category) =>
  adminApi.get("/admin/merchants", { params: category && category !== "all" ? { category } : {} }).then((r) => r.data);
export const adminServicePros = (service) =>
  adminApi.get("/admin/service-pros", { params: service && service !== "all" ? { service } : {} }).then((r) => r.data);
export const adminWaitlist = () => adminApi.get("/admin/waitlist").then((r) => r.data);

export const formatApiError = (e) => {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return String(d);
};
